export default "__VITE_ASSET__CANryKqT__"